export const parseSummaryToSuiteOption = (daikins: any, summaryChoice: any, formValues: any, summaryItem: any) => {
  // Return
  let suiteJsonItem: any = {};
  if (!summaryChoice) return suiteJsonItem;

  const mainLine = Object.keys(summaryChoice.mains).length;
  const extraLine = Object.keys(summaryChoice.extras).length;

  suiteJsonItem[`daikin_pricing`] = "";
  suiteJsonItem[`main_line`] = mainLine;
  suiteJsonItem[`wifi_line`] = 1;
  suiteJsonItem[`extra_line`] = extraLine;
  suiteJsonItem[`dk_pe_admin_percent`] = 19;
  suiteJsonItem[`state`] = formValues.state;

  // item #1
  suiteJsonItem[1] = {
    [`daikin_option_1`]: 1,
    [`recom_dk_option_1`]: 0,
    [`pmdk_1`]: "",
    [`total_cooling_capacity_1`]: summaryItem?.coolKw,
    [`total_heating_capacity_1`]: summaryItem?.heatKw,
    [`install_dk_1`]: "Yes",
    install_standard: "Daikin Standard Install",
    [`subtotal_dk_1`]: summaryItem?.pdf?.subTotal.substring(1),
    [`gst_dk_1`]: summaryItem?.pdf?.gst.substring(1),
    [`grandtotal_dk_1`]: summaryItem?.totalPrice.substring(1),
    isSend: 1,
    install_qty: summaryItem?.numOfDaikin,
    delivery: "Daikin Factory Delivery",
    products: getProductFromMainLine(1, 'product', mainLine, false, summaryChoice.mains ,daikins?.dk_main),
    extras: getProductFromMainLine(1, 'extra', extraLine, false, summaryChoice.extras ,daikins?.dk_extra),
    wifi: {
      "1": {
        "id": null,
        "partNumber": null,
        "productName": null,
        "wifi_dk_type1_1": "",
        "qty_wifi_dk1_1": ""
      }
    },
  }

  for (let i = 2; i < 7; i++) {
    suiteJsonItem = {
      ...suiteJsonItem,
      [i]: {
        [`daikin_option_${i}`]: 0,
        [`recom_dk_option_${i}`]: 0,
        [`pmdk_${i}`]: "",
        [`total_cooling_capacity_${i}`]: "",
        [`total_heating_capacity_${i}`]: "",
        [`install_dk_${i}`]: "Yes",
        install_standard: "Daikin Standard Install",
        [`subtotal_dk_${i}`]: "",
        [`gst_dk_${i}`]: "",
        [`grandtotal_dk_${i}`]: "",
        isSend: 0,
        install_qty: 0,
        delivery: "Daikin Factory Delivery",
        products: getProductFromMainLine(i, 'product', mainLine, true, summaryChoice.mains ,daikins?.dk_main),
        extras: getProductFromMainLine(i, 'extra', extraLine, true, summaryChoice.extras ,daikins?.dk_extra),
        wifi: {
          "1": {
            "id": null,
            "partNumber": null,
            "productName": null,
            [`wifi_dk_type1_${i}`]: "",
            [`qty_wifi_dk1_${i}`]: "",
          }
        },
      }
    }
  }

  return suiteJsonItem;
}

const getProductFromMainLine = (key: number, category: string, line: number, init: boolean, mains: any, productData: any) => {
  let result = {};
  for (let i = 0; i < line; i++) {
    const partNumber = Object.keys(mains)[i];
    const product = getProductDataFromPartNumber(productData, partNumber);

    if (category === 'product') {
      result = {
        ...result,
        [i + 1]: {
          id: init ? null : product?.id,
          partNumber: init ? null : partNumber,
          productName: init ? null : product?.name,
          [`main_dk_type${i + 1}_${key}`]: init ? "" : product?.short_name,
          [`qty_main_dk${i + 1}_${key}`]: init ? "" : mains[partNumber].toString()
        }
      }
    } else {
      result = {
        ...result,
        [i + 1]: {
          id: init ? null : product?.id,
          partNumber: init ? null : partNumber,
          productName: init ? null : product?.name,
          [`extra_dk_type${i + 1}_${key}`]: init ? "" : product?.short_name,
          [`qty_ext_dk${i + 1}_${key}`]: init ? "" : mains[partNumber]?.qty.toString(),
          [`price_ext_dk${i + 1}_${key}`]: init ? "" : mains[partNumber]?.cost.toString()
        }
      }
    }
  }
  return result;
}

const getProductDataFromPartNumber = (productData: any, partNumber: string) => {
  if (!productData) return {};
  return productData.filter((item: any) => item.part_number === partNumber)[0];
}

export const unescape = (s: string) => {
  return s.replace(/&amp;/g, "&")
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">")
          .replace(/&#39;/g, "'")
          .replace(/&quot;/g, '"');
}